import React, { createContext, useContext, useEffect, useReducer, useState } from 'react';
import { DOPAMENU_STORAGE_KEY, dopamenuReducer, initialDopamenu, restoreDopamenu } from '../utils/dopamenu';

const DopamenuContext = createContext(null);

export function DopamenuProvider({ children }) {
  const [state, dispatch] = useReducer(dopamenuReducer, undefined, () => {
    try {
      return restoreDopamenu(window.localStorage.getItem(DOPAMENU_STORAGE_KEY));
    } catch (_error) {
      return initialDopamenu();
    }
  });
  const [storageUnavailable, setStorageUnavailable] = useState(false);
  useEffect(() => {
    try {
      window.localStorage.setItem(DOPAMENU_STORAGE_KEY, JSON.stringify(state));
      setStorageUnavailable(false);
    } catch (_error) {
      setStorageUnavailable(true);
    }
  }, [state]);

  return <DopamenuContext.Provider value={{ state, dispatch, storageUnavailable }}>{children}</DopamenuContext.Provider>;
}

export function useDopamenu() {
  const context = useContext(DopamenuContext);
  if (!context) throw new Error('Dopamenu requires DopamenuProvider');
  return context;
}
